import { forwardRef } from "react";

interface ExtraCommentsSectionProps {
  className?: string;
}

export const ExtraCommentsSection = forwardRef<HTMLTextAreaElement, ExtraCommentsSectionProps>(
  ({ className = "" }, ref) => {
    return (
      <div
        className={`grid gap-3 grid-rows-[auto_1fr] relative p-3 rounded-md border border-gray-200 ${className}`.trim()}
      >
        <label className="font-bold" htmlFor="extra_comments">
          Extra comments for the MIKIPlus team
        </label>
        <textarea
          name="extra_comments"
          className="w-full h-full rounded-md border border-gray-200 p-2 min-h-[5rem] resize-none"
          ref={ref}
        />
      </div>
    );
  },
);

ExtraCommentsSection.displayName = "ExtraCommentsSection";
